<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <el-button-group>
          <el-button
            class="btnc"
            size="small"
            type="warning"
            @click="muldialogVisible = true"
          >批量完成</el-button>
          <el-button
            class="btnc"
            size="small"
            type="success"
            @click="mulAssignDialogVisible = true"
          >批量指派</el-button>
        </el-button-group>
        <el-button-group>
          <el-button
            class="btnc"
            size="small"
            type="primary"
            @click="addWorkOrder"
          >添加工单</el-button>
        </el-button-group>
        <el-dialog
          title="添加工单"
          :visible.sync="dialogVisibleForm"
          width="25%"
        >
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :errors.sync="errors"
            :disable-redirect="true"
            label-width="80px"
          >
            <el-form-item
              required
              prop="bike_no"
              label="车辆编号"
            >
              <el-input
                v-model="form.bike_no"
                class="limitwidth"
              />
            </el-form-item>
            <el-form-item
              required
              prop="type"
              label="工单类型"
            >
              <el-select
                filterable
                clearable
                v-model="form.type"
                placeholder="请选择"
                class="limitwidth"
              >
                <el-option
                  v-for="item in typeForm"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              required
              prop="reason"
              label="原因"
            >
              <el-input
                v-model="form.reason"
                class="limitwidth"
              />
            </el-form-item>
          </el-form>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button @click="dialogVisibleForm = false">取 消</el-button>
            <el-button
              type="primary"
              @click="onSubmit('form')"
            >确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

    <el-table
      ref="multipleTable"
      :data="users"
      resource="admin-users"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
        prop="id"
      />
      <el-table-column
        prop="bike_no"
        label="车牌号"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
        <!--      <el-table-column-->
        <!--        prop="box_no"-->
        <!--        label="中控号"-->
        <!--        align="center"-->
        <!--        show-overflow-tooltip-->
        <!--        min-width="120"-->
        <!--      />-->
        <!-- <el-table-column prop="trouble_part_name" label="工单类型"/> -->
        <el-table-column
        prop="type"
        label="工单类型"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.type == 3 || scope.row.type == 5 "
            type="danger"
            effect="plain"
          >{{ scope.row.trouble_part_name }}</el-tag>
          <el-tag
            v-else-if="scope.row.type == 1"
            type="warning"
          >{{ scope.row.trouble_part_name }}</el-tag>
          <el-tag
            v-else-if="scope.row.type == 2"
            type="success"
          >{{ scope.row.trouble_part_name }}</el-tag>
          <el-tag
            v-else-if="scope.row.type == 7"
            type="info"
          >{{ scope.row.trouble_part_name }}</el-tag>
          <el-tag
            v-else-if="scope.row.type == 8 || scope.row.type == 9 ||scope.row.type == 10 ||scope.row.type == 6"
            type="danger"
            effect="dark"
          >{{ scope.row.trouble_part_name }}</el-tag>
          <el-tag v-else>{{ scope.row.trouble_part_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        align="center"
        show-overflow-tooltip
        min-width="100"
        label="原因"
      />
      <!-- <el-table-column label="区域地勤人员">
        <template #default="{ row }">
          <el-tag
            v-for="i of row.workers"
            :key="i.id"
            class="mr-1"
          >
            {{ i.name }}
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="fix_worker_name"
        label="接单人"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
        <!--      <el-table-column-->
        <!--        prop="fix_worker_phone"-->
        <!--        label="手机号"-->
        <!--        align="center"-->
        <!--        show-overflow-tooltip-->
        <!--        min-width="100"-->
        <!--      />-->
        <el-table-column
        prop="area_name"
        align="center"
        show-overflow-tooltip
        min-width="100"
        label="区域"
      />
      <el-table-column
          prop="insert_time"
          align="center"
          show-overflow-tooltip
          min-width="100"
          label="创建时间"
      />
        <!--      <el-table-column-->
        <!--        prop="times"-->
        <!--        align="center"-->
        <!--        show-overflow-tooltip-->
        <!--        min-width="80"-->
        <!--        label="插入次数"-->
        <!--      />-->
        <!-- <el-table-column prop="created_at" show-overflow-tooltip label="创建时间"/> -->
        <el-table-column
        prop="fix_start_time"
        align="center"
        show-overflow-tooltip
        min-width="100"
        label="接单时间"
      />
      <el-table-column
        prop="planned"
        label="工单进度"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.planned_status == 1"
            type="danger"
          >{{ scope.row.planned }}</el-tag>
          <el-tag
              v-else-if="scope.row.planned_status == 2"
              type="warning"
          >{{ scope.row.planned }}
          </el-tag>
            <el-tag
                v-else-if="scope.row.planned_status == 3"
                type="success"
            >{{ scope.row.planned }}
            </el-tag>
            <el-tag
                v-else-if="scope.row.planned_status == 4"
                type="warning"
            >{{ scope.row.planned }}
            </el-tag>
            <el-tag
                type="success"
                v-else-if="scope.row.planned_status == 5"
            >{{ scope.row.planned }}
            </el-tag>
            <el-tag
                type="default"
                v-else-if="scope.row.planned_status == 6"
            >{{ scope.row.planned }}
            </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="fix_end_time"
        align="center"
        show-overflow-tooltip
        min-width="120"
        label="完成时间"
      />
      <el-table-column
        label="报修状态"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.fix_status"
            type="success"
          >已维修</el-tag>
          <el-tag
            v-else
            type="danger"
          >未维修</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        width="280"
        fixed="right"
      >
        <template #default="{ row }">
          <el-button
            size="small"
            @click="ditailClick(row)"
          >详情</el-button>
          <el-button
            size="small"
            type="warning"
            v-if="row.is_over"
            @click="OperationOverDialog(row)"
          >
            点击完成
          </el-button>
          <el-button
            size="small"
            type="success"
            v-if="row.is_zhipai"
            @click="OperationAssignDialog(row)"
          >
            点击指派
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
    <el-dialog
      class="tabs-fx"
      title="详情"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-dialog
        width="30%"
        title="维修图片"
        :visible.sync="innerVisible"
        append-to-body
      >
        <img
          v-for="(i,key) in rows.fix_image"
          :key="key"
          :src="i"
          alt="测试"
        >
      </el-dialog>
      <div class="bigC">
        <div
          class="info-wrp"
          style="width:50%"
        >
          <div class="title">故障信息</div>
          <div class="info-item">
            <span>车牌号：</span> <span>{{ rows.bike_no }}</span>
          </div>
          <div class="info-item">
            <span>工单类型：</span> <span>{{ rows.trouble_part_name }}</span>
          </div>
          <div class="info-item">
            <span>原因：</span> <span>{{ rows.reason }}</span>
          </div>
          <div class="info-item">
            <span>工单级别：</span> <span>{{ rows.times }}（越大越紧急）</span>
          </div>
          <div class="info-item">
            <span>区域地勤人员：</span> <span style="line-height: 1.4;">{{ rows.area_worker }}</span>
          </div>
          <div class="info-item">
            <span>维修状态：</span> <span style="color: rgb(96, 98, 102);">
              <span
                v-if="rows.fix_status"
                type="success"
              >已维修</span>
              <span
                v-else
                type="danger"
              >未维修</span></span>
          </div>
          <div class="info-item"><span>接单时间：</span> <span>{{ rows.fix_start_time }}</span></div>
          <div class="info-item"><span>报警时间：</span> <span>{{ rows.insert_time }}</span></div>
          <div v-show="rows.fix_status == '1'">
            <div class="title">维修信息</div>
            <div class="info-item">
              <span>实际维修人员：</span> <span>{{ rows.fix_worker }}</span>
            </div>
            <div class="info-item">
              <span>手机号码：</span> <span>{{ rows.fix_worker_phone }}</span>
            </div>
            <div class="info-item">
              <span>维修位置：</span> <span style="line-height: 1.4;">{{ rows.fix_part }}</span>
            </div>
            <div class="info-item">
              <span>维修图片：</span> <a
                href="#"
                v-show="is_img_show"
                @click="innerVisible = true"
                style="color:green;"
              >点击查看图片</a>
            </div>
            <div class="info-item"><span>维修时间：</span> <span>2019-07-11 02:42:00</span></div>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:50%"
        >
          <!-- <p class="info-title">操作车辆记录</p> -->
          <div class="table-class">
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
            >
              <el-tab-pane
                label="限制警报类型"
                name="first"
                style="color:red;"
              >限制警报类型</el-tab-pane>
              <el-tab-pane
                label="不限警报类型"
                name="second"
                style="color:green;"
              >不限警报类型</el-tab-pane>
            </el-tabs>
            <el-table
              :data="warningLogs"
              style="width: 100%"
            >
              <el-table-column
                prop="created_at"
                label="时间"
                align="center"
                width="170"
              />
              <!-- <el-table-column
                prop="bike_no"
                label="车牌号"
                align="center"
                width="130"
                show-overflow-tooltip
              /> -->
              <el-table-column
                prop="type_name"
                label="报警类型"
                align="center"
                width="135"
                show-overflow-tooltip
              />
              <el-table-column
                prop="source"
                label="报警来源"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="body"
                label="报警日志"
                align="center"
                width="90"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-popover
                    trigger="click"
                    placement="top"
                  >
                    <pre> {{ scope.row.body }}</pre>
                    <div
                      slot="reference"
                      class="name-wrapper"
                    >
                      详情
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 批量完成 -->
    <el-dialog
      title="批量操作完成"
      :visible.sync="muldialogVisible"
      width="30%"
    >
      <span>确定批量设为已完成吗？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="muldialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="mulOperation"
        >确 定</el-button>
      </span>
    </el-dialog>

    <!-- 单个完成 -->
    <el-dialog
      title="操作完成"
      :visible.sync="dialogOverVisible"
      width="30%"
    >
      <span>确定设为已完成吗？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogOverVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="OperationOver"
        >确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量指派 -->
    <el-dialog
      title="批量操作指派"
      :visible.sync="mulAssignDialogVisible"
      width="30%"
    >
      <el-form>
        <el-form-item
          required
          label="指派地勤人员:"
        >
          <el-select
            v-model="worker_id"
            placeholder="请选择人员"
            class="widm"
          >
            <el-option
              v-for="item in usersOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="mulAssignDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="mulOperationAssign"
        >确 定</el-button>
      </span>
    </el-dialog>

    <!-- 单个指派 -->
    <el-dialog
      title="指派"
      :visible.sync="AssignDialogVisible"
      width="30%"
    >
      <div class="info-wrp">
        <div class="title">故障信息</div>
        <div class="info-item">
          <span>车牌号：</span> <span>{{ rows.bike_no }}</span>
        </div>
        <div class="info-item">
          <span>工单类型：</span> <span>{{ rows.trouble_part_name }}</span>
        </div>
        <div class="info-item">
          <span>原因：</span> <span>{{ rows.reason }}</span>
        </div>
      </div>
      <el-form>
        <el-form-item
          label-width="124px"
          required
          label="指派地勤人员:"
        >
          <el-select
            v-model="worker_id"
            placeholder="请选择人员"
            class="widm"
          >
            <el-option
              v-for="item in usersOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="AssignDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="OperationAssign"
        >确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import LzForm from "@c/LzForm";
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import {
  getWorkOrders,
  getworkOrderTypes,
  addworkOrder,
  mulOverWorkOrder,
  mulAssignWorkOrder,
  getWarningByWorkOrderId
} from "@/api/work-order";
import { getAreas } from "@/api/area";
import { getWorkers } from "@/api/workers";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    LzForm,
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "type",
          label: "工单类型",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "status",
          label: "报修状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: "0",
              name: "未维修"
            },
            {
              id: "1",
              name: "已维修"
            }
          ]
        },
        {
          type: "time-between",
          field: "time_between",
          label1: "接单时间-开始",
          label2: "接单时间-结束"
        },
        {
          tpye: "super-input",
          label: "车牌号/手机号",
          field: "bike_id_fix_info"
        }
      ],
      multipleSelection: [],
      muldialogVisible: false,
      dialogOverVisible: false,
      mulAssignDialogVisible: false,
      AssignDialogVisible: false,
      assign_work_order_id: "",
      over_work_order_id: "",
      worker_id: "",
      usersOptions: [],
      users: [],
      warningLogs: [],
      page: null,
      first_blood: true,
      dialogVisible: false,
      innerVisible: false,
      typeForm: [],
      activeName: "first",
      rows: {
        fix_status: "",
        bike_no: "",
        trouble_part_name: "",
        area_worker: "",
        fix_start_time: "",
        fix_worker: "",
        fix_worker_phone: "",
        fix_part: "",
        reason: "",
        fix_image: [],
        fix_end_time: "",
        insert_time: "", // 报警时间
        tiems: 1
      },
      is_img_show: false,
      dialogVisibleForm: false,
      form: {
        bike_no: "",
        reason: "",
        type: ""
      },
      errors: {},
      rules: {
        bike_no: [
          { required: true, message: "请输入车辆编号", trigger: "blur" }
        ],
        reason: [{ required: true, message: "请输入原因", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }]
      }
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],

  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(55, newVal);
        const {
          data: { data, meta }
        } = await getWorkOrders(newVal.query);
        this.users = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    const [{ data: areas }, { data: bike_trouble_parts }] = await Promise.all([
      getAreas({ all: 1 }),
      getworkOrderTypes()
    ]);

    this.search[0].options.push.apply(this.search[0].options, areas);
    this.search[1].options.push.apply(
      this.search[1].options,
      bike_trouble_parts
    );
    this.typeForm = bike_trouble_parts;
    const [{ data: workers }] = await Promise.all([getWorkers({ all: 1 })]);
    this.usersOptions = [];
    workers.map(e => {
      this.usersOptions.push({ value: e.id, label: e.name });
    });
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[5].options.push.apply(
          this.search[5].options,
          merchant.data
        );
      }
    }
  },
  methods: {
    handleSelectionChange(val) {
      // 多选改变时触发
      this.multipleSelection = val.map(i => i.id);
      // console.log(this.multipleSelection)
    },
    mulOperation() {
      mulOverWorkOrder({ ids: this.multipleSelection }).then(res => {
        res.then(data => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogVisibleForm = false;
          this.reload();
        });
      });
      this.muldialogVisible = false;
    },
    OperationOverDialog(row) {
      // 单个完成
      this.dialogOverVisible = true;
      this.over_work_order_id = row.id;
    },
    OperationOver() {
      mulOverWorkOrder({ ids: [this.over_work_order_id] }).then(res => {
        res.then(data => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogOverVisible = false;
          this.reload();
        });
      });
      this.dialogOverVisible = false;
    },
    OperationAssignDialog(row) {
      // 单个指派弹框
      this.AssignDialogVisible = true;
      this.rows.bike_no = row.bike_no;
      this.rows.trouble_part_name = row.trouble_part_name; // 报修部分
      this.rows.reason = row.reason;
      this.assign_work_order_id = row.id;
    },
    OperationAssign() {
      // 单个指派操作
      mulAssignWorkOrder({
        ids: [this.assign_work_order_id],
        worker_id: this.worker_id
      }).then(res => {
        res.then(data => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.AssignDialogVisible = false;
          this.reload();
        });
      });
      this.AssignDialogVisible = false;
    },
    mulOperationAssign() {
      // 批量指派操作
      mulAssignWorkOrder({
        ids: this.multipleSelection,
        worker_id: this.worker_id
      }).then(res => {
        res.then(data => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.mulAssignDialogVisible = false;
          this.reload();
        });
      });
      this.mulAssignDialogVisible = false;
    },
    async ditailClick(row) {
      // 详情
      this.activeName = "first";

      this.rows.fix_status = row.fix_status;
      this.rows.bike_no = row.bike_no;
      this.rows.trouble_part_name = row.trouble_part_name; // 报修部分
      this.rows.fix_start_time = row.fix_start_time;
      this.rows.area_worker = "";
      row.workers.map(i => {
        this.rows.area_worker += i.name + "、";
      });
      this.rows.fix_worker = row.fix_over_worker_name;
      this.rows.reason = row.reason;
      this.rows.fix_worker_phone = row.fix_over_worker_phone;
      this.rows.times = row.times;
      this.rows.id = row.id;
      this.rows.fix_part = row.fix_part; // 实际维修部分
      this.rows.fix_image = JSON.parse(row.fix_img);
      if (this.rows.fix_image != null) {
        this.is_img_show = true;
      }
      this.rows.fix_end_time = row.fix_end_time;
      this.rows.insert_time = row.insert_time;
      this.dialogVisible = true;
      const [{ data: warningLogs }] = await Promise.all([
        getWarningByWorkOrderId({ id: row.id })
      ]);
      // console.log(warningLogs)
      this.warningLogs = warningLogs;
    },
    async handleClick(tab, event) {
      console.log(tab);
      var params = { id: this.rows.id };
      if (tab.name == "second") {
        params = { id: this.rows.id, is_limit_type: 0 };
      }
      const [{ data: warningLogs }] = await Promise.all([
        getWarningByWorkOrderId(params)
      ]);
      // console.log(warningLogs)
      this.warningLogs = warningLogs;
    },
    addWorkOrder() {
      this.dialogVisibleForm = true;
    },
    onSubmit(formName) {
      console.log(11);
      this.$refs[formName].validate(valid => {
        if (valid) {
          addworkOrder(this.form).then(res => {
            res.then(data => {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.dialogVisibleForm = false;
              this.reload();
            });
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scope>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
    width: 20%;
    .btnc {
      margin-bottom: 10px;
    }
  }
}
.limitwidth {
  width: 80%;
  margin-right: 10px;
}
.info-wrp {
  margin-top: -50px;
}
.info-wrp .title {
  font-size: 16px;
  margin: 40px 0 10px;
  padding-top: 10px;
  border-top: 1px solid #ccc;
}
.info-wrp .info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}
.info-wrp .info-item > span:first-child {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.info-wrp .pic-wrp > div:first-child {
  width: 120px;
  text-align: right;
}
.widm {
  width: 200px;
}
.bigC {
  display: flex;
  justify-content: space-between;
}
.table-class {
  height: 500px;
  overflow: auto;
}
</style>
